module.exports = __webpack_public_path__ + "linux-large.svg";